export const servicePath = process.env.REACT_APP_SERVICE_PATH;
export const localPath = process.env.REACT_APP_LOCAL_PATH;
export const stripePk = process.env.REACT_APP_STRIPE_PK;
export const defaultDirection = 'ltr';